<template>
  <div class="case">
    <banner :img="require('@/assets/img/bgtop.jpg')" title="产品列表" :height="150" />
    <div class="case-section">
      <div
        v-for="(category, categoryIndex) in caseCategories"
        :key="categoryIndex"
        class="case-category"
      >
        <h4 class="category-title">{{ category.title }}</h4>
        <div class="case-section-content">
          <div
            v-for="(cas, index) in category.items"
            :key="cas.Id"
            class="case-section-content-list"
          >
            <router-link
              :to="{ name: 'casedetails', params: { id: cas.Id } }"
              class="product-image-link"
            >
              <img
                v-lazy="cas.ImgUrl || require(`@/assets/img/${cas.Img}`)"
                :alt="cas.Title"
                class="product-image"
                :class="{ 'loading': isLoading }"
                @load="isLoading = false"
                @error="isLoading = false"
              />
            </router-link>
            <div
              class="content-list-abstract"
              :class="{ 'abstract-active': (categoryIndex + index) % 2 === 0 }"
            >
              <p class="abstract-title">{{ cas.Title }}</p>
              <div class="abstract-content-wrapper">
                <p class="abstract-content" :title="cas.Content">{{ cas.Content }}</p>
              </div>
              <div class="more">
                <router-link
                  class="text-decoration"
                  :to="{ name: 'casedetails', params: { id: cas.Id } }"
                >
                  <span>more</span>
                  <img src="../assets/img/sanjiao.png" alt="more arrow" class="arrow-icon" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner.vue";

export default {
  components: {Banner},
  data() {
    return {
      isLoading: true, // 控制图片加载状态
      caseCategories: [
        {
          title: "S6系列智能BMS 一体机",
          items: [
            {
              Id: 1000,
              Img: "product-s618-1000.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526575668_903_product-s618-1000.png",
              Title: "s628 28串一体机",
              Content: "S628 系列智能电池管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测、无线传输等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 2000,
              Img: "product-s618-2000.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526614459_910_product-s618-2000.png",
              Title: "s618 18串一体机",
              Content: "S618 系列智能电池管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测、无线传输等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 3000,
              Img: "product-s618-3000.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526666578_163_product-s618-3000.png", // 可替换为实际URL
              Title: "s608 8串一体机",
              Content: "S608 智能电池管理系统是由益华通盛科技专为举升车（平台）量身打造的新一代智能电池管理解决方案。系统针对24V电压平台应用场景，深度融合“强抗干扰、实时监控、便捷维护”等核心需求，全面提升设备运行的可靠性与运维效率，适用于各类24V举升车及作业平台",
            },
          ],
        },
        {
          title: "小金刚系列智能BMS 一体机",
          items: [
            {
              Id: 3338,
              Img: "product-xjg-3338.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526786860_941_product-xjg-3338.png", // 可替换为实际URL
              Title: "X338-1550H",
              Content: "小金刚系列智能BMS管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 3360,
              Img: "product-xjg-3360.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526817999_456_product-xjg-3360.png", // 可替换为实际URL
              Title: "X360-0850S",
              Content: "小金刚系列智能BMS管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 3369,
              Img: "product-xjg-3369.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526849411_884_product-xjg-3369.png", // 可替换为实际URL
              Title: "X369-1550S",
              Content: "小金刚系列智能BMS管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 3487,
              Img: "product-xjg-3487.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526876757_301_product-xjg-3487.png", // 可替换为实际URL
              Title: "X487-0880S",
              Content: "小金刚系列智能BMS管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测等功能，支持多种电池类型，适用于工业车辆",
            },
            {
              Id: 3512,
              Img: "product-xjg-3512.png",
              ImgUrl: "https://forklift.ehuatech.com.cn/forklift-test/2026/03/03/1772526938534_109_product-xjg-3512.png", // 可替换为实际URL
              Title: "X512-1550S",
              Content: "小金刚系列智能BMS管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测等功能，支持多种电池类型，适用于工业车辆",
            },
          ],
        },
        {
          title: "S6系列智能BMS 分体机",
          items: [
            {
              Id: 4000,
              Img: "product-s618-4000.png",
              ImgUrl: "", // 可替换为实际URL
              Title: "S618 分体机",
              Content: "主从分离",
            },
          ],
        },
        {
          title: "w17 4g模块",
          items: [
            {
              Id: 5000,
              Img: "product-s618-5000.png",
              ImgUrl: "", // 可替换为实际URL
              Title: "4g模块",
              Content: "支持华为协议",
            },
            {
              Id: 6000,
              Img: "product-s618-6000.png",
              ImgUrl: "", // 可替换为实际URL
              Title: "wifi模块",
              Content: "支持其他协议",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.case {
  margin: 20px auto;
  max-width: 1200px;
}

.case-category {
  margin-bottom: 40px;
  padding: 20px;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.category-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #1a75bb;
  padding-bottom: 10px;
  border-bottom: 2px solid #1a75bb;
}

.case-section-content-list {
  display: flex;
  margin-bottom: 20px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-section-content-list:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.product-image-link {
  display: block;
  text-decoration: none;
  margin-right: 20px;
}

.product-image {
  width: 250px;
  height: auto;
  border-radius: 8px;
  transition: opacity 0.3s ease;
  opacity: 1; /* 移除默认半透明效果 */
  object-fit: cover;
  max-height: 200px;
  cursor: pointer; /* 鼠标悬停显示为手形指针 */
}

.product-image-link:hover .product-image {
  opacity: 0.9;
}

.product-image.loading {
  opacity: 0.7; /* 加载中状态 */
}

.content-list-abstract {
  flex: 1;
  transition: background-color 0.3s ease;
  padding: 10px 0;
}

.abstract-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.abstract-content-wrapper {
  max-height: 100px;
  overflow: hidden;
  margin-bottom: 15px;
}

.abstract-content {
  font-size: 0.95rem;
  color: #666;
  white-space: pre-line; /* 保留换行符 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.more {
  margin-top: 10px;
  text-align: right;
}

.text-decoration {
  text-decoration: none;
  color: #1a75bb;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.arrow-icon {
  width: 16px;
  height: auto;
  vertical-align: middle;
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.text-decoration:hover .arrow-icon {
  transform: translateX(5px);
}
</style>
